import LocalizationStore from '../Stores/LocalizationStore'
import * as React from 'react'
import ReactTable, { CellInfo } from 'react-table'
import * as moment from 'moment'
import DateTimeHelper from '../Helpers/DateTimeHelper'
import ActionsLocalService from '../Services/ActionsLocalService'
import QuestionnairesStore from '../Stores/QuestionnairesStore'
import { getPaymentSchedule } from '../Helpers/PaymentScheduleHelper'

export class PaymentScheduleItemModel {

    constructor(date: Date, sum: number) {
        this.date = date
        this.sum = sum
    }

    date: Date
    sum: number
}

export class PaymentScheduleTableItem {
    constructor(item: PaymentScheduleItemModel) {
        this.date = DateTimeHelper.formatDateForList(item.date.toString())
        this.sum = item.sum
    }

    date: string
    sum: number
}

export function onChangePSItem(date: string, disableValidation: boolean) {

    const questionnairesStore = QuestionnairesStore.getInstance()
    let creditCondition = questionnairesStore.getItem.credit.creditCondition
    let day = parseInt(date.split('.')[0], 10)

    let arr = getPaymentSchedule(creditCondition.paymentsScheduleJson)

    for (let i = 0; i < arr.length; i++) {
        if (!disableValidation && arr[i].date < new Date()) {
            continue
        }
        if (day > 31) {
            alert('invalid date format')
            break
        }

        arr[i].date = changeDay(day, arr[i].date, disableValidation)
    }

    let scheduleObj = {}
    for (let i = 0; i < arr.length; ++i) {
        scheduleObj[moment(arr[i].date, 'DD.MM.YYYY').format()] = arr[i].sum
        // dates[i] = moment(schedule[i].date + '', 'DD.MM.YYYY').format()
        // scheduleObj[dates[i] + ''] = sums[i]
    }

    creditCondition.paymentsScheduleJson = scheduleObj as Array<PaymentScheduleItemModel>

    ActionsLocalService.getInstance().updateCreditConditionInQ(creditCondition)
}

export function EditMonth(month: number) {

    const questionnairesStore = QuestionnairesStore.getInstance()
    let creditCondition = questionnairesStore.getItem.credit.creditCondition

    let arr = getPaymentSchedule(creditCondition.paymentsScheduleJson)

    for (let i = 0; i < arr.length; i++) {
        arr[i].date = moment(arr[i].date).add(month, 'M').toDate()
    }

    let scheduleObj = {}
    for (let i = 0; i < arr.length; ++i) {
        scheduleObj[moment(arr[i].date, 'DD.MM.YYYY').format()] = arr[i].sum
        // dates[i] = moment(schedule[i].date + '', 'DD.MM.YYYY').format()
        // scheduleObj[dates[i] + ''] = sums[i]
    }

    creditCondition.paymentsScheduleJson = scheduleObj as Array<PaymentScheduleItemModel>

    ActionsLocalService.getInstance().updateCreditConditionInQ(creditCondition)
}

export function changeDay(day: number, date: Date, disableValidation: boolean): Date {
    let sourceDate = moment(date).date(day)

    if (sourceDate.toDate().getDate() !== day) {
        day--
        sourceDate.subtract(1, 'month')
        sourceDate = moment(changeDay(day, sourceDate.toDate(), disableValidation))
    }

    if (disableValidation) {
        return sourceDate.toDate()
    }

    return sourceDate.toDate() > new Date ? sourceDate.toDate() : date
}

export function getPaymentScheduleColumns(disableValidation: boolean) {
    const localizationStore = LocalizationStore.getInstance()

    return [
        {
            Header: localizationStore.t('date'),
            maxWidth: 150,
            minWidth: 90,
            accessor: 'date',
            Cell: (cellInfo: CellInfo) => (
                <input
                    type="text"
                    value={cellInfo.row.date}
                    disabled={!disableValidation && moment(cellInfo.row.date, 'DD.MM.YYYY') < moment().startOf('day')}
                    placeholder={localizationStore.t('dd/mm/yyyy')}
                    onChange={
                        (e) => {
                            onChangePSItem(e.target.value, disableValidation)
                        }}
                />
            )
        },
        {
            Header: localizationStore.t('sum'),
            maxWidth: 400,
            minWidth: 90,
            accessor: 'sum'
        }
    ]

}

export function getPaymentScheduleUpdateFormSchema(): any {
    const localizationStore = LocalizationStore.getInstance()
    return {
        title: localizationStore.t!('Update payment schedule'),
        type: 'object',
        properties: {
            date: {
                title: localizationStore.t!('Choose the date'),
                type: 'integer',
                default: 1,
                minimum: 1,
                maximum: 31
            }
        }
    }
}

export const UIPaymentScheduleUpdateFormSchema = {
    'date': {
        'ui:widget': 'range'
    }
}

export function createStub(data: Array<PaymentScheduleItemModel>): Array<PaymentScheduleTableItem> {
    return data.map(x => new PaymentScheduleTableItem(x))
}

export function getPaymentScheduleTable(disableValidation: boolean) {
    const localizationStore = LocalizationStore.getInstance()
    const questionnairesStore = QuestionnairesStore.getInstance()

    let q = questionnairesStore!.getItem

    if (!q ||
        !q.credit ||
        !q.credit!.creditCondition) {
        return ''
    }

    return (
        <ReactTable
            data={createStub(getPaymentSchedule(q.credit!.creditCondition!.paymentsScheduleJson))}
            columns={getPaymentScheduleColumns(disableValidation)}
            defaultPageSize={12}
            className="-striped -highlight"
            noDataText={localizationStore.t('No data text')}
            filterable={true}
            pageSizeOptions={[5, 10, 20, 25, 50, 100]}
            previousText={localizationStore.t('Previous')}
            nextText={localizationStore.t('Next')}
            pageText={localizationStore.t('Page')}
            ofText={localizationStore.t('of')}
        />
    )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/PaymentScheduleItemModel.tsx